import { useQuery } from '@tanstack/react-query'
import { apiUrl, getHttpInit } from 'src/utils/api'
import { MS_TIME } from 'src/utils/timeUtils'

/**
 * @param {Object} params
 * @param {string} params.region
 */
const useDonationProductQuery = ({ region }) =>
  useQuery({
    enabled: !!region,
    retry: false,
    staleTime: MS_TIME.FIVE_MIN,
    gcTime: MS_TIME.FIVE_MIN,
    queryKey: ['donationProduct', region],
    queryFn: async () => {
      const response = await fetch(apiUrl('products/donation', { region }), getHttpInit('GET'))

      return response.ok ? response.json() : undefined
    },
    select: (data) => {
      if (data?.Response === 'Success') {
        return data?.Content?.Result?.product ?? null
      }
    },
  })

export default useDonationProductQuery
